// extracted by mini-css-extract-plugin
export default {"tag":"AnimateTag__tag__gQCEo","small":"AnimateTag__small__wqp9p","medium":"AnimateTag__medium__RnVmI","pulse":"AnimateTag__pulse__bFs7g","stopAnimation":"AnimateTag__stopAnimation__WVOVI"};
    if(module.hot) {
      // 1753686718103
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  